import axios from "axios";
import { loading } from "@/lib/loading";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ams_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  loading.inc();
  return config;
});

api.interceptors.response.use(
  (r) => {
    loading.dec();
    return r;
  },
  (err) => {
    loading.dec();
    // Normalise FastAPI 422 error arrays into a readable string so React toasts never crash.
    const d = err.response?.data?.detail;
    if (Array.isArray(d)) {
      err.response.data.detail = d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
    } else if (d && typeof d === "object") {
      err.response.data.detail = d.msg || JSON.stringify(d);
    }
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      localStorage.removeItem("ams_token");
      localStorage.removeItem("ams_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/student-login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export default api;
